// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file kikoff_canada/protobuf/services/user_service.proto (package kikoff_canada.protobuf.services, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Empty, MethodKind } from "@bufbuild/protobuf";
import { BootstrapResponse, ChangeLocaleRequest, ChangeLocaleResponse, ConfirmEmailRequest, ConfirmEmailResponse, SendConfirmationEmailResponse, ShowUserResponse } from "./user_service_pb.js";

/**
 * @generated from service kikoff_canada.protobuf.services.UserService
 */
export const UserService = {
  typeName: "kikoff_canada.protobuf.services.UserService",
  methods: {
    /**
     * @generated from rpc kikoff_canada.protobuf.services.UserService.Bootstrap
     */
    bootstrap: {
      name: "Bootstrap",
      I: Empty,
      O: BootstrapResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc kikoff_canada.protobuf.services.UserService.ShowUser
     */
    showUser: {
      name: "ShowUser",
      I: Empty,
      O: ShowUserResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc kikoff_canada.protobuf.services.UserService.SendConfirmationEmail
     */
    sendConfirmationEmail: {
      name: "SendConfirmationEmail",
      I: Empty,
      O: SendConfirmationEmailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc kikoff_canada.protobuf.services.UserService.ConfirmEmail
     */
    confirmEmail: {
      name: "ConfirmEmail",
      I: ConfirmEmailRequest,
      O: ConfirmEmailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc kikoff_canada.protobuf.services.UserService.ChangeLocale
     */
    changeLocale: {
      name: "ChangeLocale",
      I: ChangeLocaleRequest,
      O: ChangeLocaleResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

